import { ActionIcon } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

import { ImageDropzone } from 'src/Components/Shared/ImageDropzone';
import { useUploadContactProfileImage } from 'src/Hooks/Mutations/useUploadTempContactImage';

import styles from './ContactImageField.module.scss';
import { Props } from './ContactImageField.types';

const ContactImageField = ({ form, label }: Props) => {
  const { mutate: upload, isLoading: uploadLoading } = useUploadContactProfileImage({
    onSuccess: data => {
      form.setFieldValue('imagePath', data.imagePath);
      form.setFieldValue('imageUrl', data.imageUrl);
    },
  });

  return (
    <div className={styles.imageZone}>
      {form.values.imagePath ? (
        <div className={styles.imageWrapper}>
          <img src={form.values.imageUrl} className={styles.profilePicture} />
          <ActionIcon
            radius={'xl'}
            size={'sm'}
            className={styles.removeImage}
            onClick={() => {
              form.setFieldValue('imagePath', undefined);
              form.setFieldValue('imageUrl', undefined);
            }}
          >
            <IconX style={{ width: '70%', height: '70%' }} color={'#73999D'} stroke={1.5} />
          </ActionIcon>
        </div>
      ) : (
        <>
          <div className={styles.profilePictureTitle}>{label}</div>
          <ImageDropzone
            className={styles.dropzone}
            multiple={false}
            onDrop={files => upload(files[0])}
            loading={uploadLoading}
          />
        </>
      )}
    </div>
  );
};

export default ContactImageField;
